import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
// 기존 console.log를 참조
const originalConsoleLog = console.log;

// 커스터마이즈된 console.log
console.log = async function (...args) {
  // 기존 console.log의 기능은 그대로 유지
  originalConsoleLog.apply(console, args);

  // 로그 메시지를 API로 전송
  try {
    const logMessage = args.join(' ');  // 여러 인자를 하나의 문자열로 결합
    await fetch('/request/log_write', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        type: 'FRONT',
        message: logMessage,  // 로그 메시지를 전송
      }),
    });
  } catch (error) {
    originalConsoleLog('Error sending log to API:', error);
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RecoilRoot>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
